import { CSSProperties } from 'react';
import { colors } from '../../styles/colors';
import { fullContainer } from '../../styles/styleObjects';

export const styles = {
    flex: {
        display: 'flex'
    },
    notificationPopoverContainer: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 9995
    } as CSSProperties,
    subNavBarContainer: {
        width: '100%',
        backgroundColor: colors.LIGHT_GREY,
        height: 100,
        paddingLeft: 20,
        paddingRight: 30,
        paddingTop: 13,
        paddingBottom: 13,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        position: 'fixed',
        top: 100,
        zIndex: 9997
    } as CSSProperties,
    subHeaderText: {
        position: 'absolute',
        top: 72,
        left: 22
    } as CSSProperties,
    mainNavBarContainer: {
        width: '100%',
        backgroundColor: colors.NAV_BAR,
        height: 100,
        paddingLeft: 20,
        paddingRight: 30,
        paddingTop: 13,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        position: 'fixed',
        zIndex: 9998
    } as CSSProperties,
    nameText: {
        position: 'relative',
        top: -24,
        right: -1,
        bottom: 0,
        fontSize: 12,
        margin: 'auto',
        color: 'white',
        fontWeight: 900,
        textAlign: 'center',
        letterSpacing: 2
    } as CSSProperties,
    titleInfoIcon: {
        height: '0.8em',
        marginLeft: '0.2em'
    } as CSSProperties,
    navButtonIcon: {
        height: 34,
        width: 34,
        objectFit: 'contain'
    } as React.CSSProperties,
    headerText: {
        fontSize: 34,
        lineHeight: '34px',
        maxHeight: 68,
        overflow: 'hidden',
        color: colors.NAV_BAR,
        fontWeight: 'bolder',
        cursor: 'default',
        display: 'flex',
        alignItems: 'center'
    } as CSSProperties,
    navButtonsContainer: {
        height: '100%',
        width: 110,
        minWidth: 160,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingBottom: 13,
        paddingRight: 3
    } as CSSProperties,
    navTabText: (isActive: boolean) => {
        return {
            color: isActive ? 'white' : colors.HALF_WHITE,
            fontSize: 22,
            fontWeight: isActive ? 'bold' : 'lighter',
            letterSpacing: 1,
            textAlign: 'center',
            width: '100%',
            paddingTop: 27
        } as CSSProperties;
    },
    activeTabIndicator: {
        width: '100%',
        backgroundColor: 'white',
        height: 5
    },
    tabContainer: {
        height: '100%',
        flex: 1,
        display: 'flex',
        alignSelf: 'stretch',
        flexDirection: 'column',
        justifyContent: 'space-between',
        cursor: 'pointer'
    } as CSSProperties,
    flexOne: { display: 'flex', flex: 1 },
    navigationTabContainer: {
        height: '100%',
        width: 390,
        display: 'flex',
        justifyContent: 'space-between'
    } as CSSProperties,
    logoImage: {
        height: 'calc(100% + 45px)',
        objectFit: 'contain',
        marginTop: -40,
        marginBottom: -15,
        cursor: 'pointer',
    } as React.CSSProperties,
    body: {
        minHeight: '100%',
        width: '100%',
        backgroundColor: 'white'
    },
    innerNavBar: {
        ...fullContainer,
        paddingLeft: 50
    },
    iconContainer: {
        height: 34,
        width: 34,
        cursor: 'pointer'
    },
    buttonContainer: {
        height: 50,
        width: 180,
        marginLeft: 20
    },
    buttonText: {
        fontWeight: 'lighter',
        fontSize: 16
    } as React.CSSProperties,
    actionButtonInfoIcon: {
        marginTop: '9px'
    } as React.CSSProperties,
    actionButtonWhenInfoIconPresent: {
        marginLeft: '9px'
    } as React.CSSProperties
};



// WEBPACK FOOTER //
// ./src/SharedComponents/MainPageWithNavigator/NavigatorStyles.tsx